import { useAppSelector } from "types/hooks";
import { selectViewerRoleContext } from "store/authSelectors";

export function useViewerRoleContext() {
  return useAppSelector(selectViewerRoleContext);
}
